(() => {
  const loadImage = (image) => {
    if (!image?.dataset.src) return;
    image.loading = 'eager';
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  };

  const loadVideo = (video) => {
    if (video?.dataset.poster) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }
    video?.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video?.load();
  };

  const start = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const images = [...document.querySelectorAll('.figma-desktop-page img[data-src]')];
    const videos = [...document.querySelectorAll('.figma-desktop-page video[data-deferred-video]')];
    const media = [...images, ...videos];
    if (!media.length) return;
    if (!('IntersectionObserver' in window)) {
      media.forEach((item) => item.tagName === 'VIDEO' ? loadVideo(item) : loadImage(item));
      return;
    }
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadImage(entry.target);
        imageObserver.unobserve(entry.target);
      });
    }, { rootMargin: '1500px 0px' });
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        videoObserver.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    images.forEach((item) => imageObserver.observe(item));
    videos.forEach((item) => videoObserver.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
